export default __webpack_public_path__ + "static/media/Vertical_Ad_1.dd33ef72.png";